import { DEBUG_MODE } from '../utils/paramUtils'
import chatService from './ChatServiceListenerImpl'
import * as timeUtils from '../utils/timeutils'

const flatbuffers = require('../utils/flatbuffers').flatbuffers
const Schema = require('./schema_generated').chat.Schema

function getData (dataType, message) {
  let result = null
  switch (dataType) {
    case Schema.Data.Auth:
      result = message.data(new Schema.Auth());
      break
    case Schema.Data.Chat:
      result = message.data(new Schema.Chat());
      break
    case Schema.Data.ListRoom:
      result = message.data(new Schema.ListRoom());
      break
    case Schema.Data.HistoryChat:
      result = message.data(new Schema.HistoryChat())
      break
    case Schema.Data.UserStatus:
      result = message.data(new Schema.UserStatus())
      break
    case Schema.Data.IncommingMessage:
      result = message.data(new Schema.IncommingMessage())
      break
    case Schema.Data.ReadMessage:
      result = message.data(new Schema.ReadMessage())
      break
  }
  return result
}

export default function serviceMessage(bytes, store) {
  const buf = new flatbuffers.ByteBuffer(bytes)
  const message = Schema.Message.getRootAsMessage(buf)
  const dataType = message.dataType()
  const command = message.cmd()
  const statusCode = message.statusCode()
  const data = getData(dataType, message)
  let payload = {}

  switch (command) {
    case Schema.Command.LOGIN:
      payload = {userId: data.userId(), verified: data.verified()}
      chatService.onLogin(store, payload)
      break
    case Schema.Command.CHAT_MESSAGE:
      payload = { id: data.id(), content: data.content(), author: data.author(), roomId: data.roomId(),
        me: data.author() === store.state.userInfo.userId, time: timeUtils.formatTime(data.time()), checkUnread: true }
      chatService.onChatMessage(store, payload)
      break
    case Schema.Command.LIST_ROOM:
      const roomList = []
      const length = data.roomsLength()
      for (let i = 0; i < length; i++) {
        const room = data.rooms(i)
        const lastMeReadTime = room.lastMeReadTime().split('.').length > 0 ? room.lastMeReadTime().split('.')[0] : room.lastMeReadTime()
        const userStatusesLength = room.userStatusesLength()
        const userStatuses = []
        for (let j = 0; j < userStatusesLength; j++) {
          const userStatus = room.userStatuses(j)
          const userId = userStatus.userId()
          const userName = userStatus.userName()
          const status = userStatus.status()
          const lastLogin = userStatus.lastLogin()
          const lastReadTime = userStatus.lastReadTime().split('.').length > 0 ? userStatus.lastReadTime().split('.')[0] : userStatus.lastReadTime()
          userStatuses.push({ userId: userId, userName: userName,status: status,
            lastLoginTime: timeUtils.formatTime(lastLogin), lastReadTime: timeUtils.formatTime(lastReadTime) })
        }

        roomList.push({ roomID: room.roomID(), lastMeReadTime: timeUtils.formatTime(lastMeReadTime), name: room.name(), userStatuses })
      }
      payload = { roomList }
      chatService.onListRoom(store, payload)
      break
    case Schema.Command.HISTORY_CHAT:
      const roomId = data.roomId();
      if (!store.state.loadedInitData) {
        const messages = []
        const messgesLength = data.messagesLength()
        for (let i = messgesLength - 1; i >= 0; i--) {
          const message = data.messages(i)
          const payload = {id: message.id(), content: message.content(), author: message.author(), roomId: message.roomId(),
            me: message.author() === store.state.userInfo.userId, time: timeUtils.formatTime(message.time())}
          messages.push(payload)
        }
        payload = {messages: messages, roomId: roomId, isAll: true}
      } else {
        const messages = []
        const messgesLength = data.messagesLength()
        for (let i = 0; i < messgesLength; i++) {
          const message = data.messages(i)
          const payload = {id: message.id(), content: message.content(), author: message.author(), roomId: message.roomId(),
            me: message.author() === store.state.userInfo.userId, time: timeUtils.formatTime(message.time())}
          messages.push(payload)
        }
        payload = {messages: messages, roomId: roomId, isAll: false}
      }
      chatService.onHistoryChat(store, payload)
      break
    case Schema.Command.USER_STATUS:
      payload = {userId: data.userId(), status: data.status(), lastLoginTime: timeUtils.formatTime(data.lastLogin())}
      chatService.onUserStatus(store, payload)
      break
    case Schema.Command.READ_MESSAGE:
      payload = {userId: data.userId(), roomId: data.roomId(), lastReadTime: timeUtils.formatTime(data.lastReadTime())}
      chatService.onReadMessage(store, payload)
      break
    case Schema.Command.INCOMMING_MESSAGE:
      payload = {userId: data.userId(), roomId: data.roomId(), userName: data.userName(), status: data.status()}
      chatService.onIncommingMessage(store, payload)
      break
  }

  if (DEBUG_MODE) {
    console.log("command statusCode payload: ", command, statusCode, payload)
  }
}
